import React from 'react'
import { CircularProgress, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PbiChildReportViewModel } from '@rsmus/ecp-userservice'
import RsmPagination, {
  RsmPaginationPageSizes,
} from '../../rsmCoreComponents/components/RsmPagination/RsmPagination'
// eslint-disable-next-line import/no-named-as-default
import NoSearchFound from '../../rsmCoreComponents/components/NoSearchFound/NoSearchFound'
import { Styles } from '../../types'
import Unavailable from '../../pages/Unavailable/Unavailable'
import ChildReportTable from './ChildReportTable'

interface AdminPbiChildReportResultsProps {
  childReportsData: { data: PbiChildReportViewModel[]; totalRows: number }
  isChildReportError: boolean
  isMounted: boolean
  pageNumber: number
  pageSize: RsmPaginationPageSizes
  onPageChange: (pageNumber: number, pageSize: RsmPaginationPageSizes) => void
  sortColumn: string
  sortDirection: 'asc' | 'desc'
  onSorting: (columnName: string, direction: 'asc' | 'desc') => void
  onEditChildReport?: (report: PbiChildReportViewModel) => void
  onRemoveChildReport?: (report: PbiChildReportViewModel) => void
}

const styles: Styles = {
  container: () => ({
    display: 'flex',
    justifyContent: 'center',
    height: '2rem',
    marginTop: '2rem',
  }),
}

const AdminPbiChildReportResults = ({
  childReportsData,
  isChildReportError,
  isMounted,
  pageNumber,
  pageSize,
  onPageChange,
  onSorting,
  sortColumn,
  sortDirection,
  onEditChildReport,
  onRemoveChildReport,
}: AdminPbiChildReportResultsProps) => {
  const { t } = useTranslation()

  if (isChildReportError) return <Unavailable />

  if (isMounted && (!childReportsData || childReportsData.data.length === 0)) {
    return (
      <NoSearchFound title={t('PbiChildReport.NoChildReports')} subTitle="" />
    )
  }

  if (childReportsData?.data?.length > 0) {
    return (
      <>
        <ChildReportTable
          childReportsData={childReportsData}
          onSort={onSorting}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          isMounted={isMounted}
          onEditChildReport={onEditChildReport}
          onRemoveChildReport={onRemoveChildReport}
        />

        <RsmPagination
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalRows={childReportsData.totalRows}
          onPageChange={onPageChange}
        />
      </>
    )
  }

  return (
    <Box sx={styles.container}>
      <CircularProgress />
    </Box>
  )
}

export default AdminPbiChildReportResults
